// OTP authentication helpers for the share-web SPA.
// Both functions use `credentials: 'include'` so the Set-Cookie from verify
// sticks as a session cookie for subsequent gated manifest fetches.

import { getLocale } from './ui/i18n.js';

export async function requestOtp(email: string, apiBase = ''): Promise<{ ok: boolean; error?: string; retryAfter?: number }> {
  try {
    const res = await fetch(`${apiBase}/api/auth/request`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ email, locale: getLocale() }),
    });
    if (!res.ok) {
      const b = await res.json().catch(() => ({}));
      const error = (b as any).error || `request_${res.status}`;
      if (res.status === 429) {
        // Capture retryAfter from body, then Retry-After header, then default 60
        let retryAfter = 60;
        if (typeof (b as any).retryAfter === 'number' && (b as any).retryAfter > 0) {
          retryAfter = (b as any).retryAfter;
        } else {
          const hdr = res.headers.get('Retry-After');
          if (hdr) { const n = parseInt(hdr, 10); if (n > 0) retryAfter = n; }
        }
        return { ok: false, error, retryAfter };
      }
      return { ok: false, error };
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, error: String((e as Error)?.message || e) };
  }
}

export async function verifyOtp(email: string, code: string, apiBase = ''): Promise<{ ok: boolean; error?: string }> {
  try {
    const res = await fetch(`${apiBase}/api/auth/verify`, {
      method: 'POST',
      credentials: 'include', // include so Set-Cookie sticks
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ email, code, platform: 'web' }),
    });
    if (!res.ok) {
      const b = await res.json().catch(() => ({}));
      return { ok: false, error: (b as any).error || `verify_${res.status}` };
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, error: String((e as Error)?.message || e) };
  }
}

export async function signOut(apiBase = ''): Promise<{ ok: boolean }> {
  try {
    const res = await fetch(`${apiBase}/api/auth/logout`, { method: 'POST', credentials: 'include' });
    return { ok: res.ok };
  } catch {
    return { ok: false };
  }
}
